// import React from "react";
// import image from "../../../Assets/testimonial/testimonial-img.jpg";
// import { FaQuoteRight } from "react-icons/fa";
// import { IoStar } from "react-icons/io5";

// const Testimonial = () => {
//   const data = [
//     {
//       img: image,
//       name: "Zinny Divison",
//       job: "Web Developer",
//       description:
//         "Kalingabio fertilizers improved my soil health and crop yield significantly. Plants look healthier, growth is faster, and results are consistent across every farming season.",
//       rating: 4,
//     },
//     {
//       img: image,
//       name: "Zinny Divison",
//       job: "Web Developer",
//       description:
//         "Kalingabio fertilizers improved my soil health and crop yield significantly. Plants look healthier, growth is faster, and results are consistent across every farming season.",
//       rating: 4,
//     },
//   ];

//   return (
//     <div className="w-full px-4 sm:px-6 md:px-10 py-4 sm:py-8 bg-yellow-50/30">
//       <div className="flex flex-col items-center justify-center text-center">
//         <p className="text-[#92AD36] text-sm font-semibold tracking-wide">
//           TESTIMONIALS
//         </p>

//         <h2 className="text-2xl md:text-4xl font-serif text-[#000000] mt-3">
//           What Our Client Saying ?
//         </h2>
//       </div>
//       <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 bg-yellow-50/30 w-full items-start mt-8 gap-5">
//         {data.map((item, index) => (
//           <div
//             key={index}
//             className="flex w-full px-3 sm:px-5 py-3 border bg-[#F8F8F8] rounded-2xl relative gap-3 sm:gap-4"
//           >
//             {/* Left Section */}
//             <div className="flex flex-col w-[35%] sm:w-1/3 items-center">
//               <span className="h-[60px] sm:h-[70px] w-2 ml-4 sm:ml-8 bg-[#92AD36]"></span>

//               <img
//                 src={item.img}
//                 alt="image"
//                 className="w-[70px] sm:w-[50%] rounded-full ml-1 sm:ml-4"
//               />

//               <span className="h-[60px] sm:h-[70px] w-2 ml-4 sm:ml-8 bg-[#92AD36]"></span>
//             </div>

//             {/* Right Section */}
//             <div className="flex flex-col w-[65%] sm:w-2/3">
//               <span className="text-sm sm:text-base font-semibold">
//                 {item.name}
//               </span>

//               <span className="text-xs sm:text-sm text-[#585F5F] mt-1 sm:mt-2">
//                 {item.job}
//               </span>

//               <p className="mt-3 sm:mt-6 text-xs sm:text-sm text-[#585F5F] line-clamp-3">
//                 {item.description}
//               </p>

//               <div className="flex gap-1 sm:gap-2 mt-4 sm:mt-8">
//                 {[...Array(5)].map((_, i) => (
//                   <IoStar
//                     key={i}
//                     size={18}
//                     className={
//                       i < item.rating ? "text-yellow-400" : "text-gray-300"
//                     }
//                   />
//                 ))}
//               </div>

//               <span className="absolute top-3 right-3 sm:right-4 text-[#EBEBEB] text-3xl sm:text-4xl">
//                 <FaQuoteRight />
//               </span>
//             </div>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default Testimonial;

import React, { useState, useEffect, useRef } from "react";
import { FaQuoteRight } from "react-icons/fa";
import { IoStar } from "react-icons/io5";
import { MdChevronLeft, MdChevronRight } from "react-icons/md";
import API from "../../../Utils/api";

// Skeleton Card
const TestimonialSkeleton = () => (
  <div className="flex w-full px-3 sm:px-5 py-3 border bg-[#F8F8F8] rounded-2xl gap-3 sm:gap-4 animate-pulse flex-shrink-0">
    <div className="flex flex-col w-[35%] sm:w-1/3 items-center">
      <div className="h-[60px] sm:h-[70px] w-2 ml-4 sm:ml-8 bg-gray-200" />
      <div className="w-[70px] h-[70px] sm:w-20 sm:h-20 rounded-full bg-gray-200 ml-1 sm:ml-4" />
      <div className="h-[60px] sm:h-[70px] w-2 ml-4 sm:ml-8 bg-gray-200" />
    </div>
    <div className="flex flex-col w-[65%] sm:w-2/3 py-4 space-y-3">
      <div className="h-4 bg-gray-200 rounded w-1/2" />
      <div className="h-3 bg-gray-200 rounded w-1/3" />
      <div className="h-3 bg-gray-200 rounded w-full mt-4" />
      <div className="h-3 bg-gray-200 rounded w-5/6" />
      <div className="h-3 bg-gray-200 rounded w-4/6" />
      <div className="flex gap-1 mt-4">
        {Array.from({ length: 5 }).map((_, i) => (
          <div key={i} className="w-4 h-4 bg-gray-200 rounded-full" />
        ))}
      </div>
    </div>
  </div>
);

const SLIDE_INTERVAL = 3000;
const VISIBLE_COUNT = 2; // show 2 at a time on desktop

const Testimonial = () => {
  const [testimonials, setTestimonials] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [currentIndex, setCurrentIndex] = useState(0);
  const timerRef = useRef(null);

  const fetchTestimonials = async () => {
    setLoading(true);
    setError("");
    try {
      const res = await API.get("/testimonial/all");
      const data = Array.isArray(res.data) ? res.data : res.data.data || [];
      setTestimonials(data);
    } catch (err) {
      console.error("Error fetching testimonials:", err);
      setError("Failed to load testimonials.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTestimonials();
  }, []);

  // Auto slide
  useEffect(() => {
    if (testimonials.length <= VISIBLE_COUNT) return;
    timerRef.current = setInterval(() => {
      setCurrentIndex((prev) =>
        prev + 1 >= testimonials.length ? 0 : prev + 1,
      );
    }, SLIDE_INTERVAL);
    return () => clearInterval(timerRef.current);
  }, [testimonials]);

  const handlePrev = () => {
    clearInterval(timerRef.current);
    setCurrentIndex((prev) =>
      prev === 0 ? testimonials.length - 1 : prev - 1,
    );
  };

  const handleNext = () => {
    clearInterval(timerRef.current);
    setCurrentIndex((prev) => (prev + 1 >= testimonials.length ? 0 : prev + 1));
  };

  // Get 2 visible items
  const getVisible = () => {
    if (testimonials.length === 0) return [];
    if (testimonials.length === 1) return [testimonials[0]];
    const first = testimonials[currentIndex];
    const second = testimonials[(currentIndex + 1) % testimonials.length];
    return [first, second];
  };

  const visibleItems = getVisible();

  return (
    <div className="w-full px-4 sm:px-6 md:px-10 py-4 sm:py-8 bg-yellow-50/30">
      {/* Header */}
      <div className="flex flex-col items-center justify-center text-center">
        <p className="text-[#92AD36] text-sm font-semibold tracking-wide">
          TESTIMONIALS
        </p>
        <h2 className="text-2xl md:text-4xl font-serif  text-[#000000] mt-3">
          What Our Client Saying ?
        </h2>
      </div>

      {/* Error */}
      {error && !loading && (
        <div className="flex flex-col items-center py-12 text-center">
          <span className="text-4xl mb-3">😕</span>
          <p className="text-gray-500 text-sm">{error}</p>
          <button
            onClick={fetchTestimonials}
            className="mt-3 px-5 py-1.5 bg-[#92AD36] text-white rounded-lg text-xs hover:bg-[#7a9230] transition"
          >
            Try Again
          </button>
        </div>
      )}

      {/* Empty */}
      {!loading && !error && testimonials.length === 0 && (
        <div className="flex flex-col items-center py-12 text-center">
          <span className="text-4xl mb-3">💬</span>
          <p className="text-gray-500 text-sm">No testimonials yet</p>
        </div>
      )}

      {/* Slider */}
      {(loading || testimonials.length > 0) && (
        <div className="relative mt-8">
          {/* Cards */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5 overflow-hidden">
            {loading
              ? Array.from({ length: 2 }).map((_, i) => (
                  <TestimonialSkeleton key={i} />
                ))
              : visibleItems.map((item, index) => (
                  <div
                    key={`${item._id}-${index}`}
                    className="flex w-full px-3 sm:px-5 py-3 border bg-[#F8F8F8] rounded-2xl relative gap-3 sm:gap-4 transition-all duration-500"
                  >
                    {/* Left Section */}
                    <div className="flex flex-col w-[35%] sm:w-1/3 items-center">
                      <span className="h-[60px] sm:h-[70px] w-2 ml-4 sm:ml-10 bg-[#92AD36]" />
                      <img
                        src={item.logo}
                        alt={item.authorName}
                        className="w-[70px] sm:w-[50%] rounded-full ml-1 sm:ml-5 object-cover aspect-square"
                        onError={(e) => {
                          e.target.src = `https://ui-avatars.com/api/?name=${item.authorName}&background=92AD36&color=fff`;
                        }}
                      />
                      <span className="h-[60px] sm:h-[70px] w-2 ml-4 sm:ml-8 bg-[#92AD36]" />
                    </div>

                    {/* Right Section */}
                    <div className="flex flex-col w-[65%] sm:w-2/3">
                      <span className="text-sm sm:text-base font-semibold">
                        {item.authorName}
                      </span>
                      <span className="text-xs sm:text-sm text-[#585F5F] mt-1 sm:mt-2">
                        {item.jobRole || "—"}
                      </span>
                      <p className="mt-3 sm:mt-6 text-xs sm:text-sm text-[#1E1E1E] line-clamp-3">
                        {item.content}
                      </p>
                      <div className="flex gap-1 sm:gap-2 mt-4 sm:mt-8">
                        {[...Array(5)].map((_, i) => (
                          <IoStar
                            key={i}
                            size={18}
                            className={
                              i < item.rating
                                ? "text-yellow-400"
                                : "text-gray-300"
                            }
                          />
                        ))}
                      </div>
                      <span className="absolute top-3 right-3 sm:right-4 text-[#EBEBEB] text-3xl sm:text-4xl">
                        <FaQuoteRight />
                      </span>
                    </div>
                  </div>
                ))}
          </div>

          {/* Navigation Arrows */}
          {!loading && testimonials.length > VISIBLE_COUNT && (
            <div className="flex items-center justify-center gap-4 mt-8">
              <button
                onClick={handlePrev}
                className="w-10 h-10 rounded-full border-2 border-[#92AD36] text-[#92AD36] hover:bg-[#92AD36] hover:text-white transition flex items-center justify-center"
              >
                <MdChevronLeft size={22} />
              </button>

              {/* Dots */}
              <div className="flex items-center gap-2">
                {testimonials.map((_, i) => (
                  <button
                    key={i}
                    onClick={() => {
                      clearInterval(timerRef.current);
                      setCurrentIndex(i);
                    }}
                    className={`rounded-full transition-all duration-300 ${
                      i === currentIndex
                        ? "w-6 h-2.5 bg-[#92AD36]"
                        : "w-2.5 h-2.5 bg-gray-300 hover:bg-[#92AD36]/50"
                    }`}
                  />
                ))}
              </div>

              <button
                onClick={handleNext}
                className="w-10 h-10 rounded-full border-2 border-[#92AD36] text-[#92AD36] hover:bg-[#92AD36] hover:text-white transition flex items-center justify-center"
              >
                <MdChevronRight size={22} />
              </button>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default Testimonial;
